module.exports = __webpack_public_path__ + "img/tazz.66448bad.png";